export const packageCode = {
    BRO: 'Bronze',
    SIL: 'Starter',
    GOL: 'Standard',
    PLA: 'Business',
    BUP: 'Business Plus',
    ENT: 'Enterprise'
}
export const ACCOUNT_STATUS = {
    1: 'Review',
    2: 'Active',
    3: 'Suspend',
    4: 'Inactive'
}
export const SUBSCRIPTION_TYPE = {
    M: 'Monthly',
    A: 'Annual'
}
export const SUBSCRIPTION_TYPE_TH = {
    M: 'รายเดือน',
    A: 'รายปี'
}
